<template>
  <el-row style="height: 100vh;">
    <el-col :span="24" class="image-container" style="font-size:0">
      <div class="background-left">
      </div>
      <div class="part2-picture-title">
        <div style="margin-top: 9rem;opacity: 1">
          <span style="font-weight: bold">ABOUT</span>
          <br>
          <div class="puHuiTi-regular" style="font-weight: normal">
            走进鼎新
          </div>
          <div class="puHuiTi-regular content-font">
            宁波鼎兴机械传动有限公司，坐落于长三角优势区域。秉持专业理念，致力于标准化、智能化加工精心打造高品质机械产品，以专业服务客户，用实力铸就辉煌，携手共创美好天来。
          </div>
          <div style="margin-top: 30%">
          <span class="puHuiTi-regular explore_more"
                @click="$emit('route_jump',{'route':'company_profile'})">
          探索更多
        </span>

          </div>
        </div>


      </div>

      <el-image
          style="width: 100%;height: 100%"
          :src="indexPicturePart2"
          fit="cover"
      />

    </el-col>


    <div class="bottom-background">

    </div>
    <div class="bottom-background-font">
      <el-row style="width: 100%;">
        <el-col :span="8">
          <el-image
              class="footer_icon"
              :src="integrityIcon"
              fit="cover"
          />
          <div class="puHuiTi-regular icon_title">诚信</div>
          <div class="puHuiTi-regular">诚信为本，真诚经营</div>
        </el-col>
        <el-col :span="8">
          <el-image
              class="footer_icon"
              :src="shareIcon"
              fit="cover"
              style="height: 4rem;margin-top: 4.5rem"
          />
          <div class="puHuiTi-regular icon_title" style="margin-top: 1.2rem">分享</div>
          <div class="puHuiTi-regular">业绩导向，合作共赢</div>
        </el-col>
        <el-col :span="8">
          <el-image
              class="footer_icon"
              :src="innovateIcon"
              fit="cover"

          />
          <div class="puHuiTi-regular icon_title">创新</div>
          <div class="puHuiTi-regular">技术领先，自我超越</div>
        </el-col>
      </el-row>

    </div>
  </el-row>

</template>

<script setup>
import integrityIcon from "@/assets/img/icon/integrity_icon.png";
import shareIcon from "@/assets/img/icon/share_icon.png";
import innovateIcon from "@/assets/img/icon/innovate_icon.png";

const indexPicturePart2 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/index_2.png"
// const innovateIcon = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/"assets/img/icon/innovate_icon.png')
// const integrityIcon = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/"assets/img/icon/integrity_icon.png')
// const shareIcon = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/"assets/img/icon/share_icon.png')

</script>

<style scoped>
.part2_footer {
  height: 30vh;

}

.bottom-background {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: black;
  height: 25%;
  opacity: 0.9;
}

.bottom-background-font {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30%;
  color: white;
}



@keyframes zoomInOut {
  0% {
    transform: scale(1.2); /* 原始大小 */
  }
  100% {
    transform: scale(1); /* 恢复到原始大小 */
  }
}

.fade-enter-active {
  animation: zoomInOut 1s ease-in-out;


}

img {
  vertical-align: middle; /* 对其方式设置为底部对其 */
}

.part2-picture-title {
  position: absolute;
  color: white;
  font-size: 2rem;
  text-align: left;
  padding: 0.8rem 1.2rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  z-index: 1000;
  width: 26%;
  left: 2%;

}

.background-left {
  position: absolute;
  background-color: #003795;
  opacity: 0.8;
  width: 30%;
  height: 75%;
  z-index: 1000;
}


.explore_more {
  padding-bottom: 0.6rem;
  border-bottom: white solid 1px;
  font-size: 1rem;
}

.image-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.part2_position {
  position: relative;
}

.footer_title {
  position: absolute;
  top: 50%;
  left: 9%;
  right: 9%;
  color: white;
  text-align: left;
  padding: 0.8rem 1.2rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  font-size: 1.2rem;

}


.footer_icon {
  height: 4rem;
  opacity: 0.8;
  margin-top: 4rem;
}

.footer_icon:hover {
  opacity: 1;
}


.footer_icon + div {
  margin-top: 1.2rem;
  font-size: 1.2rem;
}

.footer_icon + div + div {
  margin-top: 0.5rem;
  font-weight: lighter;
}

.icon_title {
  color: white;
}

.content-font {
  font-size: 1rem;
  margin-top: 16%;
  font-weight: lighter;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8
}
</style>